import * as React from 'react';
import { useState,useRef,useEffect } from 'react';
import Button from '@mui/material/Button';
import {IconButton} from '@mui/material';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Link from '@mui/material/Link';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Header from '../components/header';
import { Formik, Form, Field } from 'formik';
import InputAdornment from '@mui/material/InputAdornment';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { MuiTextFieldFormik } from '../../../components/CustomTextField/TextField';
import { validateLoginForm } from '../../../common/utility/validators'
import { useAxios } from '../../../common/api/hooks/useAxios';
import { URL } from '../../../common/api/urls';
import { useNavigate, useLocation, Navigate } from 'react-router-dom';
import useAuth from  '../../../common/hooks/useAuth';
import useRefreshToken from '../../../common/hooks/useRefreshToken';
import { useTheme } from '@mui/material';
import WelcomeLayout from '../components/welcome-layout';
import FormContainer from '../components/form-container';
import MainLayoutContainer from '../components/main-layout';
import { TEXT_MSGS, USER_ROLE_FIELDS } from '../../../common/utility/constant';
// import bannerImg from '../../../assets/images/diwali-frontpage-banner.jpeg';
import bannerImg from '../../../assets/images/hny-frontpage-banner1.jpeg';
import miniBannerImg from '../../../assets/images/mini-banner1.jpeg';
import { requestNotificationPermission } from '../../../firebase';
import { sendFcmTokenToServer } from '../../../fcmService';
import AppErrorPopup from '../../../components/AppErrorPopup';
import { getLoginFingerprintPayload } from '../../../common/utility/deviceFingerprint';
import { clearLoginResults } from '../../../common/utility/browserLoginCoordinator';


 //form initial values for login
 const initialValues = {
  email_id: '',
  password: '',
  remember_me: true
};

const imgStyle = {
  width: "100%",
  // height: "50%",
  // align: "middle",
  marginLeft: 0, 
  marginRight: 40, 
  marginTop: 20, 
  marginBottom: 20
}

export default function Login() {
  const theme=useTheme();
  const { setAuth, persist, setPersist, auth } = useAuth();
  const refresh = useRefreshToken();
  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(true);
  
  const { cancel,responseData, error, loaded, reset,executeAPI } = useAxios();
  const {
  cancel: googleCancel, 
  responseData: googleResponseData, 
  error: googleError, 
  loaded: googleLoaded, 
  reset: googleReset, 
  executeAPI: googleExecuteAPI
} = useAxios()
  const navigate = useNavigate();
  const location = useLocation();

  const from = location.state?.from?.pathname && location.state?.from?.search?location.state?.from?.pathname +location.state?.from?.search: "/";
  const formikRef = useRef();
  
  const [msgState, setMsgState] = useState({
    open: false,
    msg:"" ,
    severity:"info"
  });
   const { open, msg,severity } = msgState;
   console.log("TestRefresh Login from location=",from,location);

  // Authentication check 
  useEffect(() => {
    let isMounted = true;
    const checkAuth = async () => {
      try {
        if (!auth?.accessToken) {
          await refresh();
        }
      } catch (err) {
        console.log("Auth refresh failed:", err);
      }
    };

    checkAuth();
    return () => {
      isMounted = false;
    };
  }, [auth?.accessToken, refresh]);

  
 /**
 * API response handler  
 */  
  useEffect(() => {
    if(loaded){
      if(responseData!=null){
        const accessToken = responseData?.token;
        setAuth({accessToken:accessToken,name:responseData.first_name+" "+responseData.last_name,role:responseData.role,resources:responseData.resources,email_id:responseData.email_id, demo:responseData.demo, tos_notify: !!responseData.tos_notify, contact_verify_notify: !!responseData.contact_verify_notify, handoff: responseData.handoff});
        
        async function saveFCMToken(){
        let fcmToken=null;
        try {
          fcmToken = await requestNotificationPermission();
          console.log("Login FCM Token:", fcmToken,responseData.role);
        } catch (error) {
          console.warn("Login FCM token not retrieved. User may have denied notifications.");
        }
        if (fcmToken) {
          await sendFcmTokenToServer(fcmToken,accessToken);
        } else {
          console.log("Login  Skipping FCM token submission due to permission denial.");
        }
        navigate(from, { replace: true });
      }
      if(responseData.role.includes(USER_ROLE_FIELDS.PRO1))
        saveFCMToken();
      else 
        navigate(from, { replace: true });
        
      }
      else if(error!==null){
        formikRef?.current.setSubmitting(false);
        if(error?.response?.status===404){
          formikRef?.current.setErrors({email_id:"Email id not registered"})
        }else if(error?.response?.status===400){
          formikRef?.current.setErrors({password:"Password is incorrect"})
        }else{
          setMsgState({open:true,msg:error?.response?.data?.message ?? `${TEXT_MSGS.NETWORK_ERROR_MSG}`
        ,severity:"info"});
        
        }
        reset();
      }
    }
  
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[loaded,responseData,error,navigate,from]);

    useEffect(()=>{
      if(googleLoaded){
        if(googleResponseData != null){
          const url = googleResponseData.auth_url
          window.location.href = url
        }else if(googleError !== null){
          setMsgState({open:true,msg:googleError?.response?.data?.message ?? `${TEXT_MSGS.NETWORK_ERROR_MSG}`,severity:"error"});
          googleReset();
        }
      }
    },[googleResponseData])


  const handleClickShowPassword = () => setShowPassword(!showPassword);
  
  
/**
 * API caller  
 */  
 const onSubmit = async (values) => {
    values.remember_me = rememberMe;
    clearLoginResults();
    const fingerprint = await getLoginFingerprintPayload();
    executeAPI(
      URL.LOGIN,
      'POST',
      JSON.stringify({ ...values, fingerprint }),
    );
  };
  // Will change in production (NEED TO BE CHANGED LATER)
 const onGoogleSubmit = () => {
    googleExecuteAPI(URL.GOOGLE_URL,"GET", {}); 
 }

 /**
 * autoclosing of the snackbar msg bar 
 */ 
  const handleClose = (event, reason) => {
    setMsgState({...msgState,open:false});
};

  // Check if user is already authenticated & redirect to market profile
  if (auth?.accessToken) {
    return <Navigate to="/market-profile" replace />;
  }


  return (
     
      <MainLayoutContainer>
        
      {/* Header component */}
        <Header showLogin={false} showIntro={true} showBoth={false}/>
       
        {/*Welcome banner left component*/}
        <WelcomeLayout/>
       
        {/* Form container for right layut */}
        <FormContainer>
          {/* <img src={bannerImg} alt="diwali_offer" style={imgStyle} /><br/> */}
          {/* <img src={miniBannerImg} alt="diwali_offer" style={{width: "100%", marginLeft: 0, marginRight: 40, marginTop: -40, marginBottom: 0}} /><br/> */}
            <Box sx={{mt:{mobile:0,tablet:0}, width:{mobile:"95%", tablet:"85%", laptop:"75%"}, mt:1 }}>
            <Typography  variant="titleMedium" >
            Who is Vtrender<sup>™</sup> Charts for? 
            </Typography>
            <Typography  variant="titleSmall" >
            <br/><br/>For anyone who is hungry..
            <br/>For anyone who wants more..
            <br/><br/>And for who else?
            <br/><u>For no one else</u>
            <br/><br/>If you seek more, Vtrender<sup>™</sup> Charts is for you..
            </Typography>
            <br/><br/><br/><br/>
            <Typography  variant="titleMedium" >
              Log in to Vtrender<sup>™</sup> Charts now and get more
            </Typography>

            <Formik innerRef={formikRef} initialValues={initialValues} onSubmit={onSubmit} validate={validateLoginForm}>
              {({values, submitForm, resetForm, isSubmitting, touched, errors}) => (
              <Form>
  
                {/* Email field */}
                <Box>
                      <Field
                      component={MuiTextFieldFormik}
                      fullWidth
                      required
                      variant="outlined" 
                      size="small" 
                      color="inputFieldColor"
                      sx={{ mt: 3, mb: 3, }}
                      name="email_id"
                      type="email"
                      label="Email"
                    />
              </Box>
             
             {/* Password field */}
              <Box>
                <Field
                  component={MuiTextFieldFormik}
                  fullWidth
                  required
                  variant="outlined" 
                  size="small" 
                  color="inputFieldColor"
                  sx={{ mb: 2 }}
                  type={showPassword ? "text" : "password"} 
                  label="Password"
                  name="password"
                  InputProps={{ 
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword}
                        >
                          {showPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                    )
                  }}
                />
              </Box>

              {/* Remember Me */}
              <Box display="flex" sx={{ mb: 2 }} justifyContent="space-between" alignItems="center">
                <Field as={FormControlLabel}
                    name='remember_me'
                    size='small'
                    control={<Checkbox 
                      checked={rememberMe}
                      onChange={()=>setRememberMe(!rememberMe)}
                      sx={{
                        color: theme.palette.secondaryTheme.shade03,
                        '&.Mui-checked': {
                          color:theme.palette.secondaryTheme.shade03,
                        },
                      }}/>
                    }
                    label={<Typography variant="linkSupportText" >
                        Remember Me
                      </Typography>
                    }
                />
                               
                {/*Forgot/reset password link  */}
                <Link href="/forgot-password" sx={{alignContent:"flex-end"}} variant="link">Forgot/Reset password?</Link>
                </Box>           
                  
                {/* submit log in button */}
                <Button type='submit' sx={{mb:2}} variant="contained" disabled={isSubmitting}
                      fullWidth>{isSubmitting ? "Loading" : "Log In"}
                </Button>

              </Form>
                )}
            </Formik>
 
              <Grid item>
                  <Typography variant="link">{"Don't have an account yet? "}  
                    <Link href="/register" variant="link" sx={{pb:6}}>  {"Register"} </Link>
                  </Typography>
              </Grid>
              <br/>
              <br/>
              <hr/>
              <br/>
              <br/>

              <Button
                    variant="outlined"
                    fullWidth
                    sx={{ 
                      mb: 2,
                      backgroundColor: 'white',
                      borderColor: '#dadce0',
                      color: '#3c4043',
                      textTransform: 'none',
                      py: 1.2,
                      '&:hover': {
                        backgroundColor: '#f8f9fa',
                        borderColor: '#dadce0',
                      }
                    }}
                    onClick={onGoogleSubmit}
                    startIcon={
                      <svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
                        <g fill="none" fillRule="evenodd">
                          <path d="M17.64 9.2045c0-.6381-.0573-1.2518-.1636-1.8409H9v3.4814h4.8436c-.2086 1.125-.8427 2.0782-1.7955 2.7164v2.2581h2.9087c1.7023-1.5668 2.6832-3.8741 2.6832-6.615z" fill="#4285F4"/>
                          <path d="M9 18c2.43 0 4.4673-.806 5.9564-2.1805l-2.9087-2.2581c-.8059.54-1.8368.859-3.0477.859-2.344 0-4.3282-1.5831-5.036-3.7104H.9574v2.3318C2.4382 15.9832 5.482 18 9 18z" fill="#34A853"/>
                          <path d="M3.9636 10.71c-.18-.54-.2822-1.1173-.2822-1.71s.1023-1.17.2823-1.71V4.9582H.9573C.3477 6.1732 0 7.5477 0 9s.348 2.8268.957 4.0418l3.0063-2.3318z" fill="#FBBC05"/>
                          <path d="M9 3.5795c1.3214 0 2.5077.4541 3.4405 1.3459l2.5813-2.5814C13.4632.8918 11.426 0 9 0 5.482 0 2.4382 2.0168.9573 4.9582L3.9636 7.29C4.6714 5.1627 6.6556 3.5795 9 3.5795z" fill="#EA4335"/>
                        </g>
                      </svg>
                    }
                  >
                    Login with Google
              </Button>
              <br/><br/><br/><br/>
 
          </Box>
 
        </FormContainer>
 
        <AppErrorPopup
          open={open}
          message={msg}
          severity={severity}
          onClose={handleClose}
          showCloseX
        />
        {/* Legacy snackbar (replaced by AppErrorPopup)
        <Snackbar
          onClose={handleClose}
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          open={open}
          autoHideDuration={SNACKBAR_AUTO_HIDE_DURATION}
        >
          <Alert severity={severity} sx={{ width: { mobile: '80%', tablet: '70%', laptop: '40%' } }}>
            {msg}
          </Alert>  
        </Snackbar>     
        */}
 
        </MainLayoutContainer>
     
  );
}